import clsx from "clsx";

type AvatarVariant = "deep-ocean" | "teal";

type AvatarProps = {
    variant?: AvatarVariant;
    initials: string;
};

const Avatar = ({ variant = "deep-ocean", initials }: AvatarProps) => {
    return (
        <div
            className={clsx(
                "flex items-center justify-center w-8 h-8 rounded-full text-white font-semibold text-xs uppercase",
                variant === "deep-ocean" && "bg-deep-ocean-20",
                variant === "teal" && "bg-teal-60"
            )}
        >
            {initials}
        </div>
    );
};

export default Avatar;
